"use strict";

exports.__esModule = true;
exports.default = void 0;
var _copyObject = _interopRequireDefault(require("./_copyObject.js"));
var _getSymbols = _interopRequireDefault(require("./_getSymbols.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return (0, _copyObject.default)(source, (0, _getSymbols.default)(source), object);
}
var _default = exports.default = copySymbols;